<app-config-top-nav></app-config-top-nav>

<div class="companies-container">
  <div *ngIf="isLoading" class="spinner-container">
    <div class="spinner"></div>
  </div>

  <div *ngIf="errorMessage" class="error-message">{{ errorMessage }}</div>

  <div class="header" *ngIf="!isLoading">
    <h2>Companies</h2>



    <div class="header-actions">
      <button class="btn btn-primary" (click)="openCreateModal()">+ New Company</button>
      <button class="btn btn-primary" (click)="goToImport()">Import Companies</button>
    </div>
  </div>

  <div class="pagination sticky" *ngIf="!isLoading">
    <div class="page-controls">
      <button (click)="prevPage()" [disabled]="currentPage === 1">Prev</button>
      <span>Page {{ currentPage }} of {{ totalPages }}</span>
      <button (click)="nextPage()" [disabled]="currentPage === totalPages">Next</button>
    </div>

    <div class="page-size">
      <label for="pageSize">Page Size:</label>
      <select id="pageSize" [(ngModel)]="pageSize" (change)="changePageSize()">
        <option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }}</option>
      </select>
    </div>
  </div>
  <div class="filters-container" *ngIf="!isLoading">
    <div class="filters-row">
      <label class="filter-field search-field">
        <app-search-bar [value]="filters.searchTerm" [debounceMs]="1000" placeholder="Search company name"
          (searchChange)="onSearchTermChange($event)">
        </app-search-bar>
      </label>
    </div>
  </div>

  <div class="companies-list">
    <div *ngFor="let company of companies$ | async" class="company-row">
      <div class="company-info">
        <div class="company-name">{{ company.name }}</div>
        <div class="company-description">{{ company.description || '' }}</div>
      </div>

      <div class="company-status">
        <span *ngIf="company.isSubtractor" class="subtractor-badge">Subcontractor</span>
      </div>

      <div class="company-actions">
        <button class="btn edit" (click)="openEditModal(company)">Edit</button>
        <button class="btn delete" (click)="confirmDelete(company)">Delete</button>
      </div>
    </div>
  </div>
</div>

<div *ngIf="modalOpen" class="modal-backdrop">
  <div class="modal company-modal" (click)="$event.stopPropagation()">
    <h2>{{ isEditMode ? 'Edit Company' : 'New Company' }}</h2>

    <form #companyForm="ngForm" (ngSubmit)="submitCompany(companyForm)">
      <label for="companyName">Name</label>
      <input id="companyName" type="text" [(ngModel)]="formModel.name" name="name" required />

      <label for="companyDescription">Description</label>
      <textarea id="companyDescription" [(ngModel)]="formModel.description" name="description">
      </textarea>

      <label class="checkbox-label">
        <input type="checkbox" [(ngModel)]="formModel.isSubtractor" name="isSubtractor" />
        Subcontractor
      </label>

      <div class="modal-buttons">
        <button type="button" class="btn btn-secondary" (click)="closeModal()">Cancel</button>
        <button type="submit" class="btn btn-primary">
          {{ isEditMode ? 'Update' : 'Create' }}
        </button>
      </div>
    </form>
  </div>
</div>

<div *ngIf="deleteConfirmOpen" class="modal-backdrop">
  <div class="modal confirm-modal" (click)="$event.stopPropagation()">
    <h2>Delete Company</h2>
    <p class="modal-text">
      Are you sure you want to delete <strong>{{ companyToDelete?.name }}</strong>?
    </p>

    <div class="modal-buttons confirm-buttons">
      <button type="button" class="btn btn-secondary" (click)="cancelDelete()">Cancel</button>
      <button type="button" class="btn btn-danger" (click)="deleteCompany()">Delete</button>
    </div>
  </div>
</div>

<div *ngIf="toastVisible" class="toast" [ngClass]="toastType">
  <img class="icon" alt="icon" />
  <span>{{ toastMessage }}</span>
</div>